import qs from 'qs'
import axios from 'axios';

// import Router from '@/router/index.js'

import { Message } from 'element-ui';

import global from '@/utils/global.js'

axios.defaults.baseURL = process.env.NODE_ENV == 'development' ? '/api' : ''

axios.interceptors.request.use(config => {
  config.headers['X-Requested-With'] = 'XMLHttpRequest'
  config.headers['token'] = global.token
  return config
},error => {
  return Promise.reject(error)
})


axios.interceptors.response.use(response => {
  if (response.data.resCode === -1 ) {
    global.logout()
  }else if(response.data.resCode === -2 ) {
    Message.error(response.data.msg)
  }
  return response
},error => {
  Message.error('Network Err:'+error.response.status)
  return Promise.reject(error)
})

const handleResponse = (data) => {
  if(data.data.resCode < 0) return Object.assign(data, { success: false })
  return Object.assign(data, { success: true })
}

// post 请求
export const apiPostData = async (url, params = {}) => handleResponse(await axios.post(url, qs.stringify(params),  { headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}} ))

// 上传post文件
export const apiPostFile = async (url, params ={}) => handleResponse(await axios.post(url, params, { headers: {'Content-Type': 'multipart/form-data' }}))

// 清理缓存数据
export const apiClearCache = () => apiPostData('/admin/user/clearCache')

// 上传文件/kefu/user/upLoadFile
export const apiUploadFile = (params) => apiPostFile('/admin/client/upLoadFile', params)

// 登录
export const apiLogin = (params) => apiPostData('/admin/main/login', params)

// 初始化
export const apiInit = () => apiPostData('/admin/user/init')

// 发送消息
export const apiSendMsg = (params) => apiPostData('/admin/client/sendMsg', params)

export const getLastReadId = (params) => apiPostData('/admin/client/getLastReadId', params)

export const getMsgById = (params) => apiPostData('/admin/client/getMsgById', params)

//消息撤回
export const apiDelMsg = (params) => apiPostData('/admin/client/delMsg', params)

//消息撤回
export const apiClearMsg = (params) => apiPostData('/admin/client/clearMsg', params)

// 获取历史消息
export const apiGetHistory = (params) => apiPostData('/admin/client/getHistory', params)

// 获取聊天列表
export const apiGetDialogList = (params) => apiPostData('/admin/client/getDialogList', params)

// 更新用户信息
export const apiUpdateClient = (params) => apiPostData('/admin/client/updateClient', params)

// 快捷回复列表
export const apiGetReplyList = (params) => apiPostData('/admin/user/getReplyList', params)  

// 添加快捷回复
export const apiAddReply = (params) => apiPostData('/admin/user/saveReply', params)

// 删除快捷回复消息
export const apiDelReply = (params) => apiPostData('/admin/user/delReply', params)

// 快捷消息排序
export const apiReplySort = (params) => apiPostData('/admin/user/replySort', params) 

// 获取单个顾客信息
export const apiGetOneDialogInfo = (params) => apiPostData('/admin/client/getDialog', params)  

// 结束会话
export const apiCloseDialogAdmin = (params) => apiPostData('/admin/client/closeDialog', params) 

// 获取客服列表
export const apiGetKefuList = (params) => apiPostData('/admin/user/getKefuList', params) 

// 转接接口
export const apiTransferKefu = (params) => apiPostData('/admin/user/transferKefu', params)

// 退出登录
export const apiLogout = () => apiPostData('/admin/user/logout')

// 获取菜单列表
export const getMenuList = () =>  apiPostData('/admin/system/getMenuList')

//保存菜单
export const apiSaveMenu = (params) => apiPostData('/admin/system/saveMenu', params)

//菜单删除
export const apiDelMenu = (params) => apiPostData('/admin/system/delMenu', params)

//获取角色列表
export const apiGetRoleList = (params) => apiPostData('/admin/system/getRoleList', params)

//保存角色
export const apiSaveRole = (params) => apiPostData('/admin/system/saveRole', params)

//删除角色
export const apiDelRole = (params) => apiPostData('/admin/system/delRole', params)

//获取角色权限菜单
export const apiGetRoleMenu = (params) => apiPostData('/admin/system/getRoleMenu', params)

//保存角色菜单权限信息
export const apiSaveRoleMenu = (params) => apiPostData('/admin/system/saveRoleMenu', params)

// 获取企业账号列表
export const apiGetEntList = (params) => apiPostData('/admin/system/getEntList', params) 

// 新增编辑企业账号
export const apiSaveEnt = (params) => apiPostData('/admin/system/saveEnt', params)

// 删除企业账号
export const apiDelEnt = (params) => apiPostData('/admin/system/delEnt', params) 

// 客服列表(在线列表页面)
export const apiGetKefuListSecond = (params) => apiPostData('/admin/system/getKefuList', params)   

// 新增编辑客服
export const apiSaveKefu = (params) => apiPostData('/admin/system/saveKefu', params)  

// 删除客服
export const apiDelKefu = (params) => apiPostData('/admin/system/delKefu', params) 

// 获取顾客列表
export const apiGetCustomerList = (params) =>  apiPostData('/admin/client/getList', params)  

// 获取顾客对话框历史消息
export const apiGetCusDialogHistory = (params) => apiPostData('/admin/client/getDialogHistory', params)

// 上传客服头像
export const apiUploadKefuAvatar = (params) => apiPostFile('/admin/system/upLoadFile', params)  

// 获取企业配置
export const apiGetEntConfig = (params) => apiPostData('/admin/config/getEntConfig', params)

// 保存企业配置
export const apiSaveEntConfig = (params) => apiPostData('/admin/config/saveEntConfig', params)

// 获取超链接
export const apiGetLink = (params) => apiPostData('/admin/domain/getLink', params)

// 修改个人信息
export const apiSaveSelfInfo = (params) => apiPostData('/admin/user/save', params) 

// 获取留言列表
export const apiGetLeaveList = (params) => apiPostData('/admin/client/getLeaveList', params) 

// 删除留言
export const apiDelLeave = (params) => apiPostData('/admin/client/delLeave', params)

// 设置在线离线
export const apiSetStatus = (params) => apiPostData('/admin/user/setStatus', params) 

// 加入IP黑名单
export const apiAddIpBlack = (params) => apiPostData('/admin/system/addIpBlack', params) 

// 获取IP黑名单列表
export const apiGetIpBackList = (params) => apiPostData('/admin/system/getIpBackList', params)

// 删除IP黑名单
export const apiDelIpBlack = (params) =>  apiPostData('/admin/system/delIpBlack', params) 

// 导入数据
export const apiReplyFileImport = (params) => apiPostFile('/admin/user/saveReplyFile', params)

// 导出数据
export const apiReplyFileExport = () => apiPostData('/admin/user/exportReplyFile')

// 一键登录
export const apiGetLoginToken = (params) => apiPostData('/admin/user/getLoginToken', params) 

// 获取配置
export const apiGetConfig = () => apiPostData('/admin/main/getConfig') 

// 翻译
export const apiTranslation = (params) => apiPostData('/admin/client/translation', params)

export const apiTranslationMsg = (params) => apiPostData('/admin/client/translationMsg', params)